import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { Field } from 'formik';
import { formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';

const CallInclusionPriorityField = ({ darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl sx={{ margin: '0 !important' }} isInvalid={!!errors.priority && touched}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack sx={stackStyling(true)} direction="row" >
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)} color={darkMode ? 'white' : 'black'}>
                        Priority <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} fontSize="sm" color={darkMode ? 'gray.300' : 'gray.600'} maxWidth={250}>
                        Enter the priority for this call inclusion.
                    </Text>
                </Box>
                <Box flex="1" minWidth="250px">
                    <Box sx={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingTop: '8px', marginRight: '6px' }}>
                        <VStack width="100%" alignItems="normal">
                            <Field component={NumberField}
                                id="priority"
                                name="priority"
                                validate={value => !value && 'Priority is required'}
                                error={errors.priority}
                                customWidth="100%"
                                {...props}
                            />
                            {errors.priority && (
                                <Text color="red.500" fontSize="xs" mt={1} mr={8} textAlign="right">
                                    {errors.priority}
                                </Text>
                            )}

                        </VStack>
                        {isHovered && (
                            <FieldToolTip
                                label="Enter a priority."
                                ariaLabel="calling-rate-name-tip"
                                left="25px"
                                top="25px"
                            />
                        )}
                    </Box>
                </Box>

            </Stack>
        </FormControl>
    );
};

export default CallInclusionPriorityField;
